import MailIcon from "@/components/decision-tree/components/SurveyItem/components/Question/questionTypes/EmailAndName/MailIcon";

interface EmailInputBaseProps {
  value: string;
  onChange: (value: string) => void;
  placeholder?: string;
  error?: string;
}

export const EmailInputBase = ({ value, onChange, placeholder, error}: EmailInputBaseProps) => {
  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const newValue = e.target.value;
    onChange(newValue);
  };

  const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === 'Enter' || e.keyCode === 13) {
      e.preventDefault();
      e.currentTarget.blur();
    }
  };

  return (
    <div className="input-field-container">
      {/* Background container */}
      <div className="input-background" />

      {/* Mail icon */}
      <div className="input-icon">
        <MailIcon />
      </div>

      {/* Input field */}
      <input
        type="email"
        value={value}
        placeholder={placeholder ?? ''}
        className={`input-field ${error ? 'input-field-error' : ''}`}
        onChange={(e) => handleChange(e)}
        onKeyDown={handleKeyDown}
      />
    </div>
  );
};